import { HttpClient } from '@angular/common/http';
import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { FormControl, FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA }
	from '@angular/material/dialog';
import { MatRadioModule } from '@angular/material/radio';
import { MatFormFieldModule } from '@angular/material/form-field';
import { TranslateModule } from '@ngx-translate/core';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

import { ORDER_SERVER_URL } from '../../../../../config';
import { pageTransitions } from '../../../../animations/page-transitions';
import { ConnectionService } from '../../../../services/connection.service';
import { DatacenterShareViewDialogComponent } from '../../../share-view-layout/datacenter-share-view-dialog.component';

const GET_DETAILED_REPORT_URL = `${ ORDER_SERVER_URL }/v3/scheduleBusinessOrders/detailedReport`;

export interface DetailedReportData {
	id?: string[];
}

@Component({
	selector: 'copo-detailed-report-dialog',
	templateUrl: './detailed-report-dialog.component.html',
	styleUrl: './detailed-report-dialog.component.css',
	animations: pageTransitions,
	encapsulation: ViewEncapsulation.Emulated,
	imports: [

		MatButtonModule,
		MatIconModule,
		TranslateModule,
		FormsModule,
		ReactiveFormsModule,

		MatFormFieldModule,

		MatRadioModule
	]
})

export class DetailedReportDialogComponent implements OnInit {
	detailedReportFormGroup = new FormGroup({
		type: new FormControl('type', { nonNullable: true, validators: [Validators.required] }),
		period: new FormControl('period', { nonNullable: true, validators: [Validators.required] })
	});

	constructor(

		private readonly dialogRef: MatDialogRef<DatacenterShareViewDialogComponent>,

		@Inject(MAT_DIALOG_DATA) public dialogData: DetailedReportData,
		readonly http: HttpClient,
		private readonly connectionService: ConnectionService
	) {}

	ngOnInit() {
		this.setInitialData();
	}

	downloadReport() {
		const url = new URL(GET_DETAILED_REPORT_URL);
		const type = this.detailedReportFormGroup.controls.type.value;
		const period = this.detailedReportFormGroup.controls.period.value;
		const params = url.searchParams;
		params.append('type', type);
		params.append('period', period);
		params.append('id', this.dialogData.id ? this.dialogData.id.toString() : '');
		params.append('access_token', this.connectionService.getDownloadAccessToken());
		open(url.toString());
		this.closeDialog();
	}

	setInitialData() {
		this.detailedReportFormGroup.patchValue({
			type: 'N',
			period: 'C'
		});
	}

	closeDialog() {
		this.dialogRef.close();
	}
}
